<div class="row tracker-page">
  <div class="medium-12 columns" *ngIf="hasCountData">
    <div class="row report-stats word-wrap text-center float-left full-width">
      <div class="column small-12" *ngFor="let chunk of chunkStatus;let i = index;" [ngClass]="organizerStatuses | trackerStylePipe:chunk:i">
        <div class="row">
          <div class="column pointer medium-4" *ngFor="let status of chunk" [ngStyle]="{'background': status.colorCode}"
               [ngClass]="{'selected': view == status.value, 'medium-6': chunk.length == 2,'medium-3': chunk.length == 3, 'medium-12': chunk.length == 1}"
               (click)="toggle(status.value)">
            <div class="status-ellipsis" style="text-transform: capitalize">{{ status.value }}</div>
            <div>{{ status.count }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="column medium-12 large-12 indy-tables badge-tables" style="font-size: 14px">
    <input style="position: absolute;left: -9999px" type="text" value="{{copyUrl}}" id="secureCopy">
    <app-tracker-paginated-table *ngIf="hasOrganizers" [setObj]="tableData" [clickableRows]="true" (onScroll)="handleScroll($event)"  (onRowAction)="handleAction($event)" (onRowClick)="handleRowSelect($event)"
                             (onSort)="sortByColumn($event)" (onInputSearchSelection)="optionSelected($event)"></app-tracker-paginated-table>
  </div>
</div>

<div class="actions" *ngIf="reveal['emailOrganizer']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['emailOrganizer']}"></div>
  <div class="reveal actions-reveal" style="width: 50% !important;" [ngClass]="{'tpiq-reveal': reveal['emailOrganizer']}">
    <div class="row">
      <div class="small-11 columns">
        <label style="text-align: center;font-size: 14pt;margin-top: 5px;font-weight: bold">Select Status</label>
      </div>
      <div class="small-1 columns" style="margin-top: 10px;cursor: pointer" (click)="hideReveal('emailOrganizer')">
        <span class="material-icons" style="font-size: 18px;cursor: pointer">close</span>
      </div>
    </div>
    <div class="row margin-top-20">
      <div class="medium-1 column"></div>
      <div class="medium-6 columns">
        <label style="font-weight: bold;color: #878787;margin-top: 10px">Status
          <app-tpiq-select-dropdown [includeNone]="false" [setData]="dropdownStatuses" [setPlaceHolder]="'Select Status'" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="setEmailStatus($event)" [setDefaultValue]="selectedEmailStatus"></app-tpiq-select-dropdown>
        </label>
      </div>
    </div>
    <div class="row footer">
      <div class="small-12 medium-12 columns btn-row">
        <div class="text-right btn-wrapper" style="padding-right: 10px">
          <button class="button small" (click)="validateStatusSelection()">NEXT</button>
          <button class="button small" style="background: #f1645a;" (click)="hideReveal('emailOrganizer')">CANCEL</button>
        </div>
      </div>
    </div>
  </div>
</div>

